module.exports = __webpack_public_path__ + "img/yacht-5.fc56bf23.jpg";